<template>
    <div class="wrap" @click="open">
        <iframe :src="pdfUrl" type="application/pdf"  @click="handlePdfClick" width="100%" height="100%"></iframe>
        <div class="footBtns">
            <Button style="width: 170px;background-color: #2A6CFD;color: white;border-color: #2A6CFD" shape="circle" size="large" @click="turnback()">返回云擎</Button>
           <!--  <Button style="width: 170px;background-color: #2A6CFD" shape="circle" type="primary" size="large" @click="ljjc">立即检测</Button> -->
            
        </div>
    </div>
</template>
<script>
    export default {
        name: 'fxjc',
        data() {
            return {
                showHome: false,
                modalStateMent: false,
                value: 0,
                pdfUrl: "/resource/北京XX科技有限公司_风险检测报告.pdf", 
            }
        },
        components: {},
        mounted() {
            console.log('报告样例',location);
        },

        methods: {
            ljjc(){
                console.log('立即检测');
                this.$router.push({ name: 'riskdetection' })
            },
            turnback(){
                //this.$router.push({ name: 'home' })
                this.$router.push({ name: 'riskdetection' })
            },
            handlePdfClick(event) {
              console.log("PDF clicked!", event);
              // 在这里处理点击事件
            },
            open(event){
                 console.log("clicked!", event);
            }
        },
    }
</script>
<style lang="less" scoped>
    .wrap {
        display: flex;
        width: 100%;
        height: 100vh;
        padding: 12px;
        flex: 1;
        overflow-y: auto;
        background-color: rgb(246, 249, 255);
        flex-direction: column;
    }
    .footBtns {
        position: fixed;
        bottom: 0;
        z-index: 999;
        display: flex;
        width: 100%;
        height: 68px;
        padding: 16px 100px;
        background-color: rgb(246, 249, 255);
        justify-content: center;
        align-items: center;
        column-gap:50px;


    }
    .float-btn {
        position: absolute;
        right: 30px;
        top: 100px;
        /* //width: 80px; */
        font-size: 16px;
        height: 80px;
        background: #2196f3;
        border-radius: 50%;
        box-shadow: 0 2px 10px rgba(33, 150, 243, 0.3);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        transition: all 0.3s ease;
        z-index: 100000; /* 必须大于 9999 */
        /* 新增以下属性确保可见 */
        opacity: 1 !important;
        visibility: visible !important;
    }


</style>
